var exports = {
  "A": "xa15a2ab7--fdabaa--item",
  "F": "xa15a2ab7--fdabaa--item--redesign",
};

module.exports = exports;
